import { useContext, useEffect, useState } from "react";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const RequestedRealProperty = ({ end }) => {
	
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	const [firstStepReady, setFirstStepReady] = useState(false);

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, requestedRealProperty: false}))
		startHere.set((p) => ({ ...p, show: true}))
		setFirstStepReady(false);
	}

	const steps = [
		{
			target: '.requestedRealPropertyFirstStep',
			title: "Enable or Disable Property",
			content: 'Click to enabled or disabled this property.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.requestedRealPropertySecondStep',
			title: "Modify Requested Property",
			content: 'Click to update this requested property.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.requestedRealPropertyThirdStep',
			title: "Main Information",
			content: 'Provide main information of your property.',
			disableBeacon: true,
			placement: "bottom",
			modalTriggers: 'requestedRealProperty',
		},
		{
			target: '.requestedRealPropertyFourthStep',
			title: "Property Images",
			content: 'Upload images of your property.',
			disableBeacon: true,
			placement: "bottom"
		},
		{
			target: '.requestedRealPropertyFifthStep',
			title: "Property Location",
			content: 'Provide where the property is located.',
			disableBeacon: true,
			placement: "bottom"
		},
		{
			target: '.requestedRealPropertySixthStep',
			title: "Other Information",
			content: 'Provide other information for your property.',
			disableBeacon: true,
			placement: "bottom"
		},
		{
			target: '.requestedRealPropertySeventhStep',
			title: "Cancel Reqeuested Property Setup",
			content: "Cancel what you've input for this requested property.",
			disableBeacon: true,
			placement: "top"
		},
		{
			target: '.requestedRealPropertyEightStep',
			title: "Publish This Property",
			content: "Publish this requested property setup.",
			disableBeacon: true,
			placement: "top"
		},
		{
			target: '.requestedRealPropertyNinthStep',
			title: "Mark Sold",
			content: "Mark this property as sold.",
			disableBeacon: true,
			placement: "top"
		},
	]

	useEffect(() => {
		const interval = setInterval(() => {
			const el = document.querySelector('.requestedRealPropertyFirstStep');
			if (el) {
				clearInterval(interval);
				setFirstStepReady(true);
			}
		}, 100);
		return () => clearInterval(interval);
	}, []);

	return (
		firstStepReady && 
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.requestedRealProperty)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="requestedRealProperty" 
			featureName="setup"
		/>
	);
}
